import { storageKey } from "./storage-keys";
import { storageService } from "./storage-service";

export const logout = async () => {
  storageService.removeItem(storageKey.token);
  storageService.removeItem(storageKey.user);
};
